import { useLang } from "../contexts/LanguageContext";
import { Link } from "react-router-dom";
import { ArrowLeft, Scale, ShieldCheck, FileText, Mail } from "lucide-react";

const T = {
  fr: {
    back: "Retour à l'accueil",
    // Mentions légales
    ml_title: "Mentions légales",
    ml_intro:
      "Conformément à la loi n° 2004-575 du 21 juin 2004 pour la Confiance dans l'Économie Numérique (LCEN), voici les informations légales de Sereno.",
    ml_publisher: "Éditeur du site",
    ml_publisher_body:
      "Sereno est un site personnel à but pédagogique. Pour toute question, contactez-nous à bonjour@sereno.money.",
    ml_host: "Hébergement",
    ml_host_body:
      "Le site est hébergé par Emergent Labs. Le nom de domaine sereno.money est enregistré chez Hostinger.",
    ml_dir: "Directrice de la publication",
    ml_dir_body: "Antonie MBIA, créatrice de Sereno.",
    ml_ip: "Propriété intellectuelle",
    ml_ip_body:
      "L'ensemble des contenus (textes, graphismes, illustrations, logo) présents sur sereno.money sont la propriété exclusive de Sereno. Toute reproduction sans autorisation écrite préalable est interdite.",
    ml_disclaimer: "Nature du service",
    ml_disclaimer_body:
      "Sereno est un outil pédagogique. Les informations, simulations et recommandations fournies ne constituent ni un conseil en investissement, ni un conseil fiscal, ni une sollicitation à investir. Chaque utilisateur reste responsable de ses décisions financières et est invité à consulter un professionnel agréé avant tout placement.",
  },
  en: {
    back: "Back to home",
    ml_title: "Legal notice",
    ml_intro:
      "In accordance with French law LCEN of 21 June 2004, here is the legal information for Sereno.",
    ml_publisher: "Site publisher",
    ml_publisher_body:
      "Sereno is a personal educational website. For any question, contact us at bonjour@sereno.money.",
    ml_host: "Hosting",
    ml_host_body:
      "The site is hosted by Emergent Labs. The domain sereno.money is registered with Hostinger.",
    ml_dir: "Publication director",
    ml_dir_body: "Antonie MBIA, creator of Sereno.",
    ml_ip: "Intellectual property",
    ml_ip_body:
      "All content (text, graphics, illustrations, logo) on sereno.money is the exclusive property of Sereno. Any reproduction without prior written authorization is prohibited.",
    ml_disclaimer: "Nature of the service",
    ml_disclaimer_body:
      "Sereno is an educational tool. The information, simulations and recommendations provided do not constitute investment advice, tax advice, or a solicitation to invest. Each user remains responsible for their financial decisions and is invited to consult a certified professional before any investment.",
  },
};

export default function LegalNotice() {
  const { lang } = useLang();
  const tr = T[lang] || T.fr;
  return (
    <div className="mx-auto max-w-3xl px-6 py-12" data-testid="legal-notice-page">
      <Link
        to="/"
        data-testid="back-home-link"
        className="mb-6 inline-flex items-center gap-2 text-base text-[#101A42] hover:text-[#A762B1]"
      >
        <ArrowLeft className="h-4 w-4" />
        {tr.back}
      </Link>
      <div className="mb-6 flex items-center gap-3">
        <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-[#101A42]/10 text-[#101A42]">
          <Scale className="h-7 w-7" />
        </div>
        <h1 className="font-serif text-4xl font-semibold text-[#101A42] sm:text-5xl">
          {tr.ml_title}
        </h1>
      </div>
      <p className="text-lg leading-relaxed text-[#4A4A4A]">{tr.ml_intro}</p>
      <Section title={tr.ml_publisher} body={tr.ml_publisher_body} />
      <Section title={tr.ml_dir} body={tr.ml_dir_body} />
      <Section title={tr.ml_host} body={tr.ml_host_body} />
      <Section title={tr.ml_ip} body={tr.ml_ip_body} />
      <Section title={tr.ml_disclaimer} body={tr.ml_disclaimer_body} accent />
    </div>
  );
}

function Section({ title, body, accent }) {
  return (
    <section
      className={`mt-8 rounded-2xl border-2 p-6 ${
        accent
          ? "border-[#A762B1]/40 bg-[#A762B1]/5"
          : "border-[#E8DFC7] bg-white"
      }`}
    >
      <h2 className="font-serif text-xl font-semibold text-[#101A42]">
        {title}
      </h2>
      <p className="mt-2 text-base leading-relaxed text-[#101A42]">{body}</p>
    </section>
  );
}
